import { Controller } from "@hotwired/stimulus";

// Maximum app name length before truncation
const MAX_APP_NAME_LENGTH = 12;

// Minimum required dimensions for app icon
const MIN_ICON_SIZE = 512;

export default class extends Controller {
  static targets = ["previewContainer", "squarePreview", "circlePreview", "appName"];

  updatePreviews(event) {
    const fileInput = event.target;
    const file = fileInput.files[0];

    const reader = new FileReader();

    reader.onload = (e) => {
      // Create an image element to check dimensions
      const img = new Image();

      img.onload = () => {
        const width = img.width;
        const height = img.height;

        // Must be square
        if (width !== height) {
          alert(
            "Please select a square image for your app icon (width must equal height exactly)."
          );
          fileInput.value = "";
          return;
        }

        // Must be at least min size
        if (width < MIN_ICON_SIZE) {
          alert(`Please select an image that is at least ${MIN_ICON_SIZE}px × ${MIN_ICON_SIZE}px.`);
          fileInput.value = "";
          return;
        }

        // The image is valid - update the preview
        this.previewContainerTarget.classList.remove("hidden");
        this.squarePreviewTarget.src = e.target.result;
        this.circlePreviewTarget.src = e.target.result;
      };

      img.src = e.target.result;
    };

    reader.readAsDataURL(file);
  }

  updateAppName(event) {
    const appName = event.target.value;
    const displayName =
      appName.length > MAX_APP_NAME_LENGTH
        ? appName.substring(0, MAX_APP_NAME_LENGTH) + "…"
        : appName;

    this.appNameTargets.forEach((element) => {
      element.textContent = displayName;
    });
  }
}
